import { useContext } from 'react';
import { format } from 'date-fns';
import { useApolloClient } from '@apollo/react-hooks';
import { Context } from './context';
import { HEADERS } from 'views/reports/fileReport/constants';
import {
  fetchAllDownloads,
  buildReportRows,
  memoizeDateFormatter,
} from './reportExportData';

/**
 * Video report CSV transform. One row per download, day-resolution dates, and no
 * deduplication -- matching what this report has always emitted. The shared work
 * lives in reportExportData.
 */
const useVideoExportData = ({ onProgress }: { onProgress?: (completed: number, total: number) => void } = {}) => {
  const { state: { queryVariables } } = useContext(Context);
  const client = useApolloClient();

  //works as callback function into export
  async function getData(recordData) {
    const formatDownloadDate = memoizeDateFormatter(
      (value) => format(new Date(String(value)), 'LLLL dd, yyyy'),
    );

    const downloadsById = await fetchAllDownloads(client, recordData, queryVariables?.filterString, onProgress);
    const rows = await buildReportRows(recordData, downloadsById, formatDownloadDate);

    return [HEADERS, rows];
  }

  return {
    getData
  }
}

export default useVideoExportData;
